import {
  optionalNameSchema,
  phoneSchema,
  requiredErrorMessage,
} from '@common/schema';
import * as yup from 'yup';

export const editCareTeamSchema = yup.object().shape({
  partner: yup
    .string()
    .when('$hasCanvasId', ([hasCanvasId], schema) =>
      hasCanvasId ? schema : schema.required(requiredErrorMessage),
    ),

  practice: yup
    .string()
    .when('$hasCanvasId', ([hasCanvasId], schema) =>
      hasCanvasId ? schema : schema.required(requiredErrorMessage),
    ),

  provider_type: yup
    .string()
    .oneOf(['Internal', 'External', 'Unknown'])
    .optional()
    .when('$hasCanvasId', ([hasCanvasId], schema) =>
      hasCanvasId ? schema : schema.required(requiredErrorMessage),
    ),

  provider: yup
    .string()
    .when(
      ['$hasCanvasId', 'provider_type'],
      ([hasCanvasId, provider_type], schema) =>
        hasCanvasId
          ? schema
          : provider_type === 'Internal'
            ? schema.required(requiredErrorMessage)
            : schema,
    ),

  provider_first_name: optionalNameSchema.when(
    ['$hasCanvasId', 'provider_type'],
    ([hasCanvasId, provider_type], schema) =>
      hasCanvasId
        ? schema
        : provider_type === 'External'
          ? schema.required(requiredErrorMessage)
          : schema,
  ),

  provider_last_name: optionalNameSchema.when(
    ['$hasCanvasId', 'provider_type'],
    ([hasCanvasId, provider_type], schema) =>
      hasCanvasId
        ? schema
        : provider_type === 'External'
          ? schema.required(requiredErrorMessage)
          : schema,
  ),

  provider_phone: phoneSchema.when(
    ['$hasCanvasId', 'provider_type'],
    ([hasCanvasId, provider_type], schema) =>
      hasCanvasId
        ? schema.strip()
        : provider_type === 'External'
          ? schema.required(requiredErrorMessage)
          : schema,
  ),

  geropsych: yup
    .string()
    .nullable()
    .transform(value => (value === '' ? null : value)),

  home_health_provider_id: yup
    .string()
    .nullable()
    .transform(value => (value === '' ? null : value)),

  cardiology: yup
    .string()
    .nullable()
    .transform(value => (value === '' ? null : value)),

  palliativeCare: yup
    .string()
    .nullable()
    .transform(value => (value === '' ? null : value)),

  neurology: yup
    .string()
    .nullable()
    .transform(value => (value === '' ? null : value)),

  socialWorker: yup
    .string()
    .nullable()
    .transform(value => (value === '' ? null : value)),

  careNavigator: yup
    .string()
    .nullable()
    .transform(value => (value === '' ? null : value)),
});
